function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import _ from 'lodash';
import moment from 'moment-timezone';
export var getSpecialHoursDays = function(specialHours, timezone) {
    var upcomingSpecialHours = _.filter(specialHours, function(specialHoursItem) {
        var specialHoursItemEndDate = moment.tz(specialHoursItem.endDate, timezone);
        var today = moment().tz(timezone).startOf('day');
        return today.isSameOrBefore(specialHoursItemEndDate);
    });
    var upcomingSpecialHoursPerDay = _.map(upcomingSpecialHours, 'hoursPerDay');
    var flattenedSpecialHoursPerDay = _.flattenDeep(upcomingSpecialHoursPerDay);
    return _.compact(flattenedSpecialHoursPerDay);
};
export var getEffectiveHours = function(pickupHours, deliveryHours, specialHours, timezone) {
    /**
   * When using updated ordering/hours settings, the top-level effectiveHours
   * object is irrelevant, as effectiveHours object nested in hoursSettings
   * are used.
   * It would be possible to wrangle the data to make this work, but the field
   * isn't used anyway. -- RTL, 8/6/2021
   */ var usingUpdatedHoursSettings = _.some(specialHours, function(specialHoursSet) {
        return _.has(specialHoursSet, 'specialOperatingHours') && !_.has(specialHoursSet, 'hoursPerDay');
    });
    if (!specialHours || usingUpdatedHoursSettings) {
        return {
            pickupHours: pickupHours,
            deliveryHours: deliveryHours
        };
    }
    var effectivePickupHours = {};
    var effectiveDeliveryHours = {};
    var specialHoursDays = getSpecialHoursDays(specialHours, timezone);
    var specialHoursThisWeek = _.filter(_.compact(specialHoursDays), function(param) {
        var date = param.date;
        return moment.tz(date, timezone).isSame(moment().tz(timezone), 'week');
    });
    if (specialHoursThisWeek) {
        _.forEach(specialHoursThisWeek, function(day) {
            _.set(effectivePickupHours, moment.tz(day.date, timezone).format('dddd'), day.pickupHours);
            _.set(effectiveDeliveryHours, moment.tz(day.date, timezone).format('dddd'), day.deliveryHours);
        });
    }
    return {
        pickupHours: _object_spread({}, pickupHours, effectivePickupHours),
        deliveryHours: _object_spread({}, deliveryHours, effectiveDeliveryHours)
    };
};
